import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import StatusAlertModel from '../../../../components/statusAlertModel/StatusAlertModel';
import { ISuccessState } from '../../../../interfaces/successState';
import { unsubscribeProtocolReport } from '../../../../services/dashboard';
import styles from './Unsubscribe.module.scss';

interface IProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  serviceId: string;
}

const Unsubscribe = (props: IProps) => {
  const { setLoading, serviceId } = props;
  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();

  const unsubscribeHandler = () => {
    setLoading(true);
    unsubscribeProtocolReport(serviceId)
      .then(() => {
        setIsSuccess({
          isSuccess: true,
          message: 'Successfully unsubscribed',
        });
        setLoading(false);
      })
      .catch((err) => {
        setIsSuccess({ isSuccess: false, message: err.message });
        setLoading(false);
      });
  };

  return (
    <Row className='page-sub-container-v2'>
      <Col>
        <>
          <Row>
            <Col className={['text-center'].join(' ')}>
              <span className={styles.title}>
                Do you want to unsubscribe protocol report?
              </span>
            </Col>
          </Row>
          <Row className=' mt-4'>
            <Col className='text-center'>
              <Button variant='primary' onClick={unsubscribeHandler}>
                Unsubscribe
              </Button>
            </Col>
          </Row>
        </>
      </Col>
      <StatusAlertModel isSuccess={isSuccess} setIsSuccess={setIsSuccess} />
    </Row>
  );
};

export default Unsubscribe;
